import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ManifestApiAdapter } from '../adapters/ManifestApiAdapter';
import { useToast } from '@shared/hooks/use-toast';

export const useManifestPreview = () => {
  const { toast } = useToast();
  const { t } = useTranslation('orderpreparationModule');
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ManifestApiAdapter(httpClient);

  return useMutation({
    mutationFn: (courierIntegrationId: number) =>
      adapter.preview({ courier_integration_id: courierIntegrationId }),
    onError: (error: any) => {
      toast({
        title: t('manifest.toast.previewError'),
        description: error?.response?.data?.message || error.message,
        variant: 'destructive',
      });
    },
  });
};
